import RestService from '../services/rest';

async function getManufacturers(limit, skip, search, order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/manufacturers?limit=${limit}&skip=${skip}&search=${search}&order=${order}&field=${field}`,
  );
}

async function getManufacturer(id) {
  return RestService.getAuthenticated(`panel/manufacturers/${id}`);
}

async function createManufacturer(manufacturer) {
  return RestService.postAuthenticated('panel/manufacturers/create', manufacturer);
}

async function updateManufacturer(manufacturer) {
  return RestService.putAuthenticated('panel/manufacturers/update', manufacturer);
}

async function deleteManufacturer(id) {
  return RestService.postAuthenticated('panel/manufacturers/delete', { id });
}

async function uploadManufacturer(file, name, id) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated(`panel/manufacturers/import?&name=${name}&id=${id}`,
    fd, {
      'Content-Type': 'multipart/form-data',
    });
}

async function getCsvManufacturersReport() {
  const response = await RestService.getAuthenticated('panel/manufacturers/report/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'manufacturers-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function getCsvManufacturerModel() {
  const response = await RestService.getAuthenticated('panel/manufacturers/csv/model', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'Modelo_Importação_Manufacturers CSV.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function uploadCsvManufacturers(file) {
  const fd = new FormData();
  fd.append('file', file);

  return RestService.postAuthenticated('panel/manufacturers/import/csv', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

export default {
  getManufacturers,
  getManufacturer,
  createManufacturer,
  updateManufacturer,
  uploadManufacturer,
  deleteManufacturer,
  getCsvManufacturersReport,
  getCsvManufacturerModel,
  uploadCsvManufacturers,
};
